export default "__VITE_PUBLIC_ASSET__5b3da566__"